module.exports = __webpack_public_path__ + "img/Option Chain1.59032ded.svg";